import React from "react";

const Motivation = () => {
  return (
    <div className="w-full pt-[100px] flex flex-col justify-start items-start gap-[20px] overflow-hidden font-poppins">
      <h1
        data-aos="fade-right"
        className="w-full text-[70px] sm:text-[100px] md:text-[140px] lg:text-[180px] xl:text-[220px] 
                   leading-[60px] sm:leading-[90px] md:leading-[120px] lg:leading-[160px] xl:leading-[200px]
                   uppercase font-semibold text-left 
                   bg-gradient-to-t from-[#76cfff] to-white bg-clip-text text-transparent"
      >
        Capture <br />
        <span className="font-playfair italic">Moments.</span>
      </h1>

      <h1
        data-aos="fade-left"
        className="w-full text-[70px] sm:text-[100px] md:text-[140px] lg:text-[180px] xl:text-[220px] 
                   leading-[60px] sm:leading-[90px] md:leading-[120px] lg:leading-[160px] xl:leading-[200px]
                   uppercase font-semibold text-right lg:text-right md:text-right sm:text-left text-left 
                   bg-gradient-to-t from-[#76cfff] to-white bg-clip-text text-transparent"
      >
        Elevate <br />
        <span className="font-playfair italic">Events.</span>
      </h1>

      <h1
        data-aos="fade-right"
        className="w-full text-[70px] sm:text-[100px] md:text-[140px] lg:text-[180px] xl:text-[220px] 
                   leading-[60px] sm:leading-[90px] md:leading-[120px] lg:leading-[160px] xl:leading-[200px]
                   uppercase font-semibold text-left 
                   bg-gradient-to-t from-[#76cfff] to-white bg-clip-text text-transparent"
      >
        Instantly <br />
        <span className="font-playfair italic">Engaging!</span>
      </h1>
    </div>
  );
};

export default Motivation;
